import React from 'react';

function PortfolioCard({project}) {
  return (
    <div className="flex flex-col lg:px-10 lg:w-1/2 justify-evenly">
      <h3 className="text-2xl font-semibold ">
        {project.name} - <i>{project.year}</i>
      </h3>

      <p>{project.description}</p>

      <ul className="flex justify-start ">
        {project.builtWith.map((item, index) => (
          <li
            key={index}
            className="inline py-2 pr-5 text-xs font-semibold text-gray-800 rounded-full"
          >
            {item}
          </li>
        ))}
      </ul>

      <ul className="flex justify-center py-3">
        <a
          role="tab"
          className="w-1/2 py-2 text-sm font-semibold text-center text-white bg-green-700 rounded-l-full hover:bg-green-800 focus:border-black focus:border-8"
          href={project.gitHubLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Github Repo Link for ${project.name}`}
        >
          Github Repo
        </a>

        <a
          role="tab"
          className="w-1/2 py-2 text-sm font-semibold text-center text-white bg-blue-700 rounded-r-full hover:bg-blue-800 focus:border-black focus:border-8"
          href={project.projectLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Project Link for ${project.name}`}
        >
          Project
        </a>
      </ul>
    </div>
  );
}

export default PortfolioCard;
